import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Mobile button atom. Used in mobile navigation.
 *
 * text1 - The toggle text.
 * text2 - The toggle text.
 * value - The value is boolean.
 */
@customElement('nn-toggle')
export class Toggle extends LitElement {
  static styles = css`
    .switch--horizontal {
      align-items: center;
      display: flex;
      gap: var(--nn-toggle_switch--horizontal_gap, 40px);
      justify-content: center;
      margin: var(--nn-toggle_switch--horizontal_margin, 0 auto);
      min-height: var(--nn-toggle_switch--horizontal_min-height, 40px);
      position: relative;
    }
    .switch--horizontal input {
      cursor: pointer;
      height: var(--nn-toggle_switch--horizontal_input_height, 24px);
      margin: var(--nn-toggle_switch--horizontal_margin, 0);
      opacity: 0;
      width: var(--nn-toggle_switch--horizontal_width, 46px);
      position: absolute;
      top: 13px;
      z-index: 2;
    }
    .switch--horizontal input:checked {
      z-index: 1;
    }
    .switch--horizontal input:checked + label {
      color: var(
        --nn-toggle_switch--horizontal_input--checked_label_color,
        #000
      );
      cursor: default;
    }
    .switch--horizontal label {
      color: var(--nn-toggle_switch--horizontal_label_color, #999);
      cursor: pointer;
      font-size: var(--nn-toggle_switch--horizontal_label_font-size, 1.125em);
      line-height: 1;
      transition: var(--nn-toggle_switch--horizontal_label_transition, 0.3s)
        ease;
      width: var(--nn-toggle_switch--horizontal_label_width, 50%);
    }
    .switch--horizontal .toggle-text-a {
      display: flex;
      justify-content: end;
      width: var(
        --nn-toggle_switch--horizontal_toggle-text-a_width,
        calc(50% - 40px)
      );
    }
    .switch--horizontal .toggle-text-b {
      display: flex;
      justify-content: start;
      width: var(
        --nn-toggle_switch--horizontal_toggle-text-a_width,
        calc(50% - 40px)
      );
    }
    .switch--horizontal .toggle-outside {
      background: var(
        --nn-toggle_switch--horizontal_toggle-outside_background,
        #437ce4
      );
      border-radius: var(
        --nn-toggle_switch--horizontal_toggle-outside_border-radius,
        2rem
      );
      height: var(--nn-toggle_switch--horizontal_toggle-outside_height, 24px);
      overflow: hidden;
      transition: var(
          --nn-toggle_switch--horizontal_toggle-outside_transition,
          0.3s
        )
        ease all;
      width: var(--nn-toggle_switch--horizontal_toggle-outside_width, 46px);
      position: relative;
    }
    .switch--horizontal .toggle-inside {
      border-radius: var(
        --nn-toggle_switch--horizontal_toggle-inside_border-radius,
        50%
      );
      background: var(
        --nn-toggle_switch--horizontal_toggle-inside_background,
        #fff
      );
      height: var(--nn-toggle_switch--horizontal_toggle-inside_height, 16px);
      transition: var(
          --nn-toggle_switch--horizontal_toggle-inside_transition,
          0.3s
        )
        ease all;
      width: var(--nn-toggle_switch--horizontal_toggle-inside_width, 16px);
      position: absolute;
      top: 4px;
    }
    .switch--horizontal input ~ .toggle-outside .toggle-inside {
      left: 5px;
    }
    .switch--horizontal input ~ .toggle-text-b {
      color: var(
        --nn-toggle_switch--horizontal_input_toggle-text-b_color,
        #999
      );
    }
    .switch--horizontal input:checked ~ .toggle-text-a {
      color: var(
        --nn-toggle_switch--horizontal_input--checked_toggle-text-a_,
        #999
      );
    }
    .switch--horizontal input:checked ~ .toggle-text-b {
      color: var(
        --nn-toggle_switch--horizontal_input--checked_toggle-text-b_,
        #000
      );
    }
    .switch--horizontal input:checked ~ .toggle-outside .toggle-inside {
      left: 20px;
    }
  `;

  @property({ type: String }) text1 = 'Paiement mensuel';

  @property({ type: String }) text2 = 'Paiement annuel';

  @property({ type: Boolean }) value = false;

  render() {
    return html`
      <div class="switch--horizontal">
        <!-- retrieve value and dispatch -->
        <input
          type="checkbox"
          id="toggle"
          .checked="${this.value}"
          .value="${this.value}"
          @change="${this._dispatchValue}"
        />
        <p class="toggle-text-a">${this.text1}</p>
        <span class="toggle-outside">
          <span class="toggle-inside"></span>
        </span>
        <p class="toggle-text-b">${this.text2}</p>
      </div>
    `;
  }

  _dispatchValue(e: Event) {
    const target = e.target as HTMLInputElement;
    this.value = target.checked;
    const event = new CustomEvent('onToggle', {
      detail: {
        value: this.value,
      },
    });
    this.dispatchEvent(event);
  }
}
